import { Component, computed, Input, OnDestroy, signal } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { LANGUAGES } from 'src/app/helpers';
import { Store } from '@ngrx/store';
import { State } from 'src/app/state/reducers';
import { AppSelectors } from 'src/app/state/app/selectors';
import { AppActions } from 'src/app/state/app/actions';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { SelectComponent } from '../select/select.component';
import { Observable, Subscription } from 'rxjs';
import { SelectOption } from '../select/select';

@Component({
    selector: 'app-language-select',
    templateUrl: './language-select.component.html',
    styleUrls: ['./language-select.component.scss'],
    imports: [CommonModule, ReactiveFormsModule, MatIconModule, MatSelectModule, SelectComponent]
})
export class LanguageSelectComponent implements OnDestroy {
  @Input() small = false;
  selectControl = new UntypedFormControl();
  subscription: Subscription;
  changeSub: Subscription;
  locale$: Observable<string>;
  $langs = signal(LANGUAGES);
  $langsOptions = computed<SelectOption[]>(() =>
    this.$langs().map((lang) => ({ value: lang.code, label: lang.localName }))
  );

  constructor(private store: Store<State>) {
    this.locale$ = this.store.select(AppSelectors.appLocale);

    // NOTE: tried to refactor to use async pipe instead of updateControl
    // Could not achieve it with using [value]="locale$|async" on mat-select FIXME
    this.subscription = this.locale$.subscribe((locale) => {
      this.updateControl(locale);
    });

    this.changeSub = this.selectControl.valueChanges.subscribe((val) => {
      this.setLanguage(val);
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if(this.changeSub) {
      this.changeSub.unsubscribe();
    }
  }

  setLanguage(lcode: string) {
    this.store.dispatch(AppActions.setLocale({ locale: lcode }));
  }

  updateControl(lcode: string) {
    this.selectControl.setValue(lcode, { emitEvent: false });
  }
}
